import React, { useState } from "react";
import "../css/Portafolio.css";

const proyectos = [
    {
        id: 1,
        titulo: "Sistema Empresarial",
        categoria: "Software",
        descripcion: "Plataforma administrativa para gestión de procesos, usuarios, reportes y control interno.",
        icono: "fa-laptop-code",
        tecnologias: ["React", "Node.js", "MongoDB"],
    },
    {
        id: 2,
        titulo: "Portal Corporativo",
        categoria: "Web",
        descripcion: "Sitio institucional moderno, optimizado y adaptable para empresas de servicios.",
        icono: "fa-globe",
        tecnologias: ["React", "Bootstrap", "SEO"],
    },
    {
        id: 3,
        titulo: "App Móvil",
        categoria: "Aplicaciones",
        descripcion: "Aplicación móvil para atención de clientes, seguimiento y gestión operativa.",
        icono: "fa-mobile-screen-button",
        tecnologias: ["React Native", "API", "Cloud"],
    },
    {
        id: 4,
        titulo: "Mesa de Ayuda",
        categoria: "Soporte IT",
        descripcion: "Sistema para gestión de tickets, soporte remoto, trazabilidad y control técnico.",
        icono: "fa-headset",
        tecnologias: ["Tickets", "Cloud", "IT"],
    },
];

const Portfolio = () => {
    const [activo, setActivo] = useState(1);
    const proyectoActivo = proyectos.find((p) => p.id === activo);

    return (
        <section className="portfolio-section">
            <div className="portfolio-container">

                <div className="portfolio-header">
                    <div>
                        <span className="portfolio-label">
                            <i className="fa-solid fa-briefcase"></i>
                            Portafolio empresarial
                        </span>

                        <h2>
                            Soluciones digitales para empresas que buscan crecer
                        </h2>

                        <p>
                            Diseñamos sistemas, plataformas y herramientas tecnológicas
                            orientadas a mejorar procesos, productividad y control empresarial.
                        </p>
                    </div>
                </div>

                <div className="portfolio-layout">

                    <div className="portfolio-list">
                        {proyectos.map((proyecto) => (
                            <button
                                key={proyecto.id}
                                className={`portfolio-item ${activo === proyecto.id ? "active" : ""}`}
                                onClick={() => setActivo(proyecto.id)}
                            >
                                <div className="portfolio-item-icon">
                                    <i className={`fa-solid ${proyecto.icono}`}></i>
                                </div>

                                <div>
                                    <h4>{proyecto.titulo}</h4>
                                    <span>{proyecto.categoria}</span>
                                </div>

                                <i className="fa-solid fa-arrow-right portfolio-arrow"></i>
                            </button>
                        ))}
                    </div>

                    <div className="portfolio-detail">
                        <div className="portfolio-detail-icon">
                            <i className={`fa-solid ${proyectoActivo.icono}`}></i>
                        </div>

                        <span className="portfolio-category">
                            {proyectoActivo.categoria}
                        </span>

                        <h3>{proyectoActivo.titulo}</h3>

                        <p>{proyectoActivo.descripcion}</p>

                        <div className="portfolio-tags">
                            {proyectoActivo.tecnologias.map((tech) => (
                                <span key={tech}>{tech}</span>
                            ))}
                        </div>

                        <button className="portfolio-btn">
                            Ver proyecto
                            <i className="fa-solid fa-arrow-right"></i>
                        </button>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Portfolio;